
import { createApp } from 'vue';

import App from './App.vue';

//Importer Axios
import axios from 'axios';

axios.defaults.baseURL = 'http://162.254.34.159:3026'; // Remplace par l'URL de ton backend en prod


// Importer le router
import router from './Router'; 

// Importer animate.css pour les animations CSS
import 'animate.css';
import '@fortawesome/fontawesome-free/css/all.css';


// Créer l'application Vue
const app = createApp(App);

// main.js
import AOS from 'aos';
import 'aos/dist/aos.css'; // Importez les styles
AOS.init({
    // offset: 200,
    duration: 1000,       // Durée par défaut
    once: true,           // Animation unique
    offset: 120,          // Décalage de déclenchement
    easing: 'ease-in-out', // Courbe d'animation
    disableMutate: true,
}
);
// Utiliser VueObserveVisibility pour détecter la visibilité des éléments
import VueObserveVisibility from 'vue-observe-visibility';
app.use(VueObserveVisibility);

// Utiliser le router
app.use(router);

app.mount('#app');